import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from './APIWrapper';


const checkAuth = async () => {
    try {
        const response = await axios.get(`${apiUrl}/auth/check-auth`, {
            withCredentials: true
        });
        if (response.data.message === "Authenticated") {
            return {
                isAuthenticated: true,
            };
        } else {
            throw new Error('Unauthorized');
        }
    } catch (error) {
        return {
            isAuthenticated: false,
        };
    }
};


const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    useEffect(() => {
        const verifyAuth = async () => {
            const authStatus = await checkAuth();
            setIsAuthenticated(authStatus.isAuthenticated);
        };

        verifyAuth();
    }, []);
    if (isAuthenticated === null) {
        return (
            <div className="loading-container">
                <div className="loading-circle"></div>
            </div>
        )
    };
    return isAuthenticated ? children : <Navigate to="/" />;
};

export { ProtectedRoute, checkAuth };

